import { environment } from "src/environments/environment";
const { BASE_URL } = environment;

export const apis = {
  login: `${BASE_URL}/v1/auth/login`,
  register: `${BASE_URL}/v1/auth/register`,
  forgot: `${BASE_URL}/v1/auth/forgot`,
  resetPassword: `${BASE_URL}/v1/auth/reset-password`,
  refreshToken: `${BASE_URL}/v1/auth/refresh-tokens`,
  getMe: `${BASE_URL}/v1/auth/me`,
  
  users: `${BASE_URL}/v1/users`,
  languages: `${BASE_URL}/v1/languages`,
  activities: `${BASE_URL}/v1/activities`,
  schools: `${BASE_URL}/v1/schools`,
  modalities: `${BASE_URL}/v1/modalities`,
  levels: `${BASE_URL}/v1/levels`,
  products: `${BASE_URL}/v1/products`,
  crews: `${BASE_URL}/v1/crews`,
  schoolInstructors: `${BASE_URL}/v1/members`,
  students: `${BASE_URL}/v1/students`,
  studentBooking: `${BASE_URL}/v1/studentBooking`,
  bookings: `${BASE_URL}/v1/bookings`,
  lessons: `${BASE_URL}/v1/lessons`,
  transactions: `${BASE_URL}/v1/transactions`,
  invoices: `${BASE_URL}/v1/invoices`,
  media: `${BASE_URL}/v1/media`,
  boxes: `${BASE_URL}/v1/boxes`,
  boxBookings: `${BASE_URL}/v1/box-bookings`,
  zones: `${BASE_URL}/v1/zones`,
  boxSizes: `${BASE_URL}/v1/box-sizes`,
  paymentMethods: `${BASE_URL}/v1/payment-methods`,
  rentalEquipmentTypes: `${BASE_URL}/v1/rental-equipment-types`,
  rentalEquipment: `${BASE_URL}/v1/rental-equipment`,
  rentalProducts: `${BASE_URL}/v1/rental-products`,
  rentals: `${BASE_URL}/v1/rentals`,
  reports: `${BASE_URL}/v1/reports`,
  money: `${BASE_URL}/v1/money`,
  dashboardV2: `${BASE_URL}/v1/dashboard-v2`,
  cash: `${BASE_URL}/v1/cash`,
  discounts: `${BASE_URL}/v1/discounts`,
  public: `${BASE_URL}/v1/public`,
  portalAccessTokens: `${BASE_URL}/v1/portal-access-tokens`
};
